import { render } from "./VeranstaltungKategorie.vue?vue&type=template&id=4357034e"
import script from "./VeranstaltungKategorie.vue?vue&type=script&lang=js"
export * from "./VeranstaltungKategorie.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__